import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getMasterBroker(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getmasters",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getMaster(payload) {
    const result = await axios.post(apiUrl + "/admin/getmasters",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function changeStatus(payload) {
    const result = await axios.post(apiUrl + "/admin/changestatus",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}
export const MasterListService = {
    getMasterBroker,
    getMaster,
    changeStatus
}